<template>
  <div
    class="vz-cookies"
    :class="{ 'vz-cookies-hide': acceptedCookies === true }"
  >
    <p class="vz-cookies-p">
      Ao utilizar nosso site, você está de acordo com nossa
      <a class="vz-cookies-a" href="/p/privacy-policy"
        >Política de privacidade</a
      >.
    </p>
    <vz-button
      class="vz-cookies-bt vz-primary"
      type="button"
      @click="acceptCookies"
      >Entendi</vz-button
    >
  </div>
</template>

<script>
import VzButton from 'vsp-web-ui-lib/components/atoms/vz-button.vue';

export default {
  name: 'CookiesAcceptance',
  components: {
    VzButton
  },

  data: () => ({
    acceptedCookies: false
  }),

  beforeMount() {
    return this.$store.dispatch('user/checkCookies').then((response) => {
      if (!response) {
        this.acceptedCookies = false;
      } else {
        this.acceptedCookies = true;
      }
    });
  },

  methods: {
    acceptCookies() {
      return this.$store
        .dispatch('user/acceptCookies', {
          acceptance: true
        })
        .then(() => {
          this.acceptedCookies = true;
        });
    }
  }
};
</script>

<style theme="dark-theater" scoped>
.vz-cookies {
  z-index: 99;
  display: flex;
  height: 95px;
  position: fixed;
  bottom: 0%;
  background-color: black;
  text-align: left;
  font-size: 13px;
  padding: 17px;
  margin: 0 auto;
  align-items: center;
  transition: bottom 3s;
}

.vz-cookies-hide {
  bottom: -100% !important;
}

.vz-cookies-bt {
  margin-left: 20px;
  margin-right: 8px;
  padding: 7px 10px;
}

@media (min-width: 400px) {
  .vz-cookies-a {
    margin-left: 4px;
  }
}

@media (min-width: 1024px) {
  .vz-cookies {
    bottom: 3%;
    margin: 0 auto;
    height: 56px;
    left: 0;
    right: 0;
    width: 34%;
    border-radius: 10px;
    font-size: 14px;
    justify-content: center;
    text-align: center;
  }
}
</style>

















































